<template>
    <div class="">
        <div class="py-2">
            <input
                class="form-input rounded-md shadow-sm form-control form-input date-picker"
                id="date-picker"
                ref="datePicker"
                type="text"
                :placeholder="placeholder"
                :value="value"
            />
        </div>
    </div>
</template>

<script>
import flatpickr from 'flatpickr';
import 'flatpickr/dist/themes/airbnb.css';
import JetInput from '@/Jetstream/Input';

export default {
    name: "DatePicker",
    components: {JetInput},
    props: {
        value: {
            required: false,
        },
        placeholder: {
            type: String,
            default: () => {
                return moment().format('DD.MM.YYYY');
            },
        },
    },
    mounted() {
        this.$nextTick(() => this.createFlatpickr());
    },
    methods: {
        createFlatpickr() {
            this.flatpickr = flatpickr(this.$refs.datePicker, {
                enableTime: false,
                enableSeconds: false,
                onClose: this.onChange,
                onChange: this.onChange,
                dateFormat: 'd.m.Y',
                altInput: true,
                altFormat: 'd.m.Y',
                allowInput: false,
                disable: [{
                    from: moment().add(1, 'days').format('DD.MM.YYYY'),
                    to: '30.12.2100'
                }],
                // static: true,
                mode: 'range',
                locale: {
                    firstDayOfWeek: 1,
                    rangeSeparator: ' - '
                },
            });
        },

        onChange() {
            if(!this.flatpickr.isOpen) {
                this.$emit('change', this.$refs.datePicker.value);
            }
        }
    }
}
</script>

<style scoped>
    .date-picker {
        min-width: 395px !important;
    }
</style>
